import { DEFAULT_LOCALE, isLocale, type Locale } from '@rythmo/shared';

/**
 * Romanian from day one, English for someone who asked for it or whose browser leads with it
 * (`docs/product/admin-web-prd.md` §6). The school's own default joins this once a school's
 * settings carry one.
 */
export function pickLocale(stored: string | null, browser: readonly string[]): Locale {
  if (stored !== null && isLocale(stored)) return stored;
  if (browser[0]?.toLowerCase().startsWith('en')) return 'en';
  return DEFAULT_LOCALE;
}
